// screens.web.ts (Web PWA Only)
import { lazy, Suspense } from 'react';

// 1. STATIC IMPORTS (Bundled instantly into the main web chunk)
// 1. STATIC IMPORTS (Bundled instantly into the main web chunk)
export { default as PaymentDoneScreen } from './payment-done/index';
export { default as SigninScreen } from './signin/index';

// 2. PRELOADABLE LAZY IMPORTS (Downloaded as separate JS chunks on demand)
export const MainScreen = lazyWithPreload(() => import('./main/index'));
export const DoctorsListScreen = lazyWithPreload(() => import('./doctors-list/index'));
export const DoctorProfileScreen = lazyWithPreload(() => import('./doctor-profile/index'));
export const ChatScreen = lazyWithPreload(() => import('./chat/index'));
export const HealthFacilitiesScreen = lazyWithPreload(() => import('./health-facilities/index'));
export const QueueListScreen = lazyWithPreload(() => import('./queue-list/index'));

// Modal screens
export { default as ChatsHistoryModal } from './modals/chat.history.modal';
export { default as VisitsHistoryModal } from './modals/visit.history.modal';
export { default as OTPModal } from './modals/otp.modal';
export { default as PaymentModal } from './modals/payment.modal';
export { default as CallModal } from './modals/call.modal';
export { default as FilePickerModal } from './modals/file.picker.modal';
export { default as TransactionsHistoryModal } from './modals/transactions.history.modal';
export { default as NotificationPreferencesModal } from './modals/notification.preferences.modal';
export { default as ProfileSettingsModal } from './modals/profile.settings.modal';
export { default as AvailabilityModal } from './modals/availability.modal';
export { default as PatientSurveyModal } from './modals/patient.survey.modal';
export { default as EndVisitConfirmationModal } from './modals/end.visit.confirmation.modal';
export { default as TermsAndConditionsModal } from './modals/terms.and.conditions.modal';
export { default as VideoPlayerModal } from './modals/video.player.modal';
export { default as ImageZoomModal } from './modals/image.zoom.modal';
export { default as PdfViewModal } from './modals/pdf.view.modal';

export function lazyWithPreload<T extends React.ComponentType<any>>(factory: () => Promise<{ default: T }>) {
  const LazyComponent = lazy(factory);

  // 🔥 THE MAGIC: Bake the Suspense boundary directly into the wrapper!
  const WrappedComponent = (props: any) => (
    <Suspense fallback={null}>
      <LazyComponent {...props} />
    </Suspense>
  );

  // Store the factory function so we can manually invoke the network download later
  WrappedComponent.preload = factory;

  return WrappedComponent as unknown as React.ComponentType<any> & { preload: () => Promise<any> };
}
